import type { BoxProps } from '@shopify/polaris';
import type { ReactNode } from 'react';

import IMAGE_ANALYTIC_EMPTY from '~/modules/analytics/assets/img/analytic-empty.png';

import { GBlockCenter, GThumbnail } from '~/presentation/ui';
import { BlockStack, Box, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

export interface CardAnalyticEmptyProps {
  boxProps?: BoxProps;
  minHeight?: string;
  description?: string;
  title?: string;
  /** Rendered under the description, e.g. a call-to-action button */
  action?: ReactNode;
}
export const CardAnalyticEmpty: React.FC<CardAnalyticEmptyProps> = ({
  boxProps,
  minHeight,
  description,
  title,
  action,
}) => {
  const { t } = useTranslation();
  const descriptionText = description || t('Data needs time to gather');

  return (
    <Box minWidth="100%" {...boxProps}>
      <GBlockCenter minHeight={minHeight}>
        <Box padding={'400'}>
          <BlockStack gap="400" align="center" inlineAlign="center">
            <div className="w-[80px] h-[80px]">
              <GThumbnail
                source={IMAGE_ANALYTIC_EMPTY}
                width="80px"
                height="80px"
                alt={t('No data yet')}
                classRemoved
              />
            </div>
            <BlockStack gap="200" align="center" inlineAlign="center">
              <Text as="h4" variant="headingSm" fontWeight="semibold">
                {title || t('No data yet')}
              </Text>
              <Text as="h4" variant="bodyMd" tone="subdued">
                {descriptionText}
              </Text>
            </BlockStack>
            {action}
          </BlockStack>
        </Box>
      </GBlockCenter>
    </Box>
  );
};
